import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getContext } from "../Global";
import { TransportTimeClass } from "./TransportTime";
/**
 * Ticks is a primitive type for encoding Time values.
 * Ticks can be constructed with or without the `new` keyword. Ticks can be passed
 * into the parameter of any method which takes time as an argument.
 * @example
 * const t = Tone.Ticks("4n"); // a quarter note as ticks
 * @category Unit
 */

export var TicksClass = /*#__PURE__*/function (_TransportTimeClass) {
  _inherits(TicksClass, _TransportTimeClass);

  var _super = _createSuper(TicksClass);

  function TicksClass() {
    var _this;

    _classCallCheck(this, TicksClass);

    _this = _super.apply(this, arguments);
    _this.name = "Ticks";
    _this.defaultUnits = "i";
    return _this;
  }
  /**
   * Get the current time in the given units
   */


  _createClass(TicksClass, [{
    key: "_now",
    value: function _now() {
      return this.context.transport.ticks;
    }
    /**
     * Return the value of the beats in the current units
     */

  }, {
    key: "_beatsToUnits",
    value: function _beatsToUnits(beats) {
      return this._getPPQ() * beats;
    }
    /**
     * Returns the value of a second in the current units
     */

  }, {
    key: "_secondsToUnits",
    value: function _secondsToUnits(seconds) {
      return Math.floor(seconds / (60 / this._getBpm()) * this._getPPQ());
    }
    /**
     * Returns the value of a tick in the current time units
     */

  }, {
    key: "_ticksToUnits",
    value: function _ticksToUnits(ticks) {
      return ticks;
    }
    /**
     * Return the time in ticks
     */

  }, {
    key: "toTicks",
    value: function toTicks() {
      return this.valueOf();
    }
    /**
     * Return the time in seconds
     */

  }, {
    key: "toSeconds",
    value: function toSeconds() {
      return this.valueOf() / this._getPPQ() * (60 / this._getBpm());
    }
  }]);

  return TicksClass;
}(TransportTimeClass);
/**
 * Convert a time representation to ticks
 * @category Unit
 */

export function Ticks(value, units) {
  return new TicksClass(getContext(), value, units);
}